import React from 'react';

export interface DividerModuleProps {
    moduleClass: string;
}

const DividerModule = ({ moduleClass }: DividerModuleProps) => (
    <section className={`marketing-container__max-width ${moduleClass}`}>
        <div className="mktg-layout-align--horizontal-desktop ">
            <div className="eds-g-cell-12-12">
                <hr />
            </div>
        </div>
    </section>
);

export default DividerModule;
